import React, { useEffect, useState } from 'react';
import { Icon, Modal, Row, Tooltip } from 'antd';
import ReactTooltip from 'react-tooltip';
import _ = require("lodash");

import { ModalRichText } from '@app/components';
import {
  deleteMinutaItemClausula,
  postMinutaItemClausula,
  postMinutaItemClausulaItemAprovado,
  putMinutaItemClausula,
} from '@app/api/minuta/Minutas';
import { ModalRichTextModel } from '@app/models/ModalRichTextModel';
import { ModalAddMinutaItemClausulaModel } from '@app/models/modalAddMinutaItemClausulaModel';

import ModalAddItemClausula from '../compontents/ModalAddItemClausula';

import './index.css';
import { int2roman } from '@app/helpers/numbers';
import { IMinutaClausula, IMinutaItemClausula, IMinutasPorTipoClausula } from '@app/models/MinutaModels';
import { ETipoClausulaNome } from '@app/enums/ETipoClausulaNomeById';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { dataPorExtenso } from '@app/helpers/dateTimeFormats';

const { confirm } = Modal;

interface Props {
  minutasPorTipoClausula: IMinutasPorTipoClausula[];
  onExecuteAnAfterActionHandle: () => void;
  enableTooltip?: boolean;
}

const MinutaContent: React.FC<Props> = ({
  minutasPorTipoClausula,
  onExecuteAnAfterActionHandle,
  enableTooltip = true,
}) => {
  const [modalVisivel, setModalVisivel] = useState<boolean>(false);
  const [modalRichText, setModalRichText] = useState<ModalRichTextModel>({
    visible: false,
  } as ModalRichTextModel);

  const [modalAddItemVisible, setModalAddItemVisible] = useState<boolean>(false);
  const [modalAddItemData, setModalAddItemData] = useState<ModalAddMinutaItemClausulaModel>({
    visible: false,
  } as ModalAddMinutaItemClausulaModel);

  const [minutaItemClausulaPart1, setMinutaItemClausulaPart1] = useState<IMinutaClausula[]>([]);
  const [minutaItemClausulaPart2, setMinutaItemClausulaPart2] = useState<IMinutaClausula[]>([]);

  useEffect(() => {
    //part1
    const minutaItemClausulaPart1 =
      minutasPorTipoClausula.find(item => item.tipoClausulaId === ETipoClausulaNome.PARTE1) ||
      ({} as IMinutasPorTipoClausula);

    if (
      minutaItemClausulaPart1 &&
      minutaItemClausulaPart1.minutaClausulas &&
      isObjNotEmpty(minutaItemClausulaPart1.minutaClausulas)
    ) {
      setMinutaItemClausulaPart1(minutaItemClausulaPart1.minutaClausulas);
    }

    //part2
    const minutaItemClausulaPart2 =
      minutasPorTipoClausula.find(item => item.tipoClausulaId === ETipoClausulaNome.PARTE2) ||
      ({} as IMinutasPorTipoClausula);

    if (
      minutaItemClausulaPart2 &&
      minutaItemClausulaPart2.minutaClausulas &&
      isObjNotEmpty(minutaItemClausulaPart2.minutaClausulas)
    ) {
      setMinutaItemClausulaPart2(minutaItemClausulaPart2.minutaClausulas);
    }
  }, [minutasPorTipoClausula]);

  const generateIdHash = (prefix: string, id: string) => prefix + '-' + id.substring(5, 12);

  const handleSetDataModalRichText = (dadosModal: ModalRichTextModel) => {
    setModalRichText(dadosModal);
    setModalVisivel(dadosModal.visible);
  };

  const handleChangeModalVisible = () => {
    setModalVisivel(!modalVisivel);
    setModalRichText({ visible: !modalVisivel } as ModalRichTextModel);
  };

  //#region Modal Add Item
  const handleModifyModalAddItemInsertData = (dadosModalAddItem: ModalAddMinutaItemClausulaModel) => {
    setModalAddItemData(dadosModalAddItem);
    setModalAddItemVisible(dadosModalAddItem.visible);
  };

  const handleModifyVisibleModalAddItem = () => {
    setModalAddItemVisible(!modalAddItemVisible);
    setModalAddItemData({ visible: !modalAddItemVisible } as ModalAddMinutaItemClausulaModel);
  };
  //#endregion

  const handleTooltipAddItemAprovado = async (
    itemIdTooltip: string,
    tipoClausulaId: string,
    clausulaMinutaId: string,
  ) => {
    var dadosModalAddItem = {
      title: 'Adicionar item',
      visible: true,
      tipoClausulaId: tipoClausulaId,
      clausulaMinutaId: clausulaMinutaId,
      onSelected: async (itemIdSelected: string) => {
        await postMinutaItemClausulaItemAprovado({
          minutaItemClausulaid: itemIdTooltip,
          itemIdSelected: itemIdSelected,
          tipoClausulaId,
        });

        await onExecuteAnAfterActionHandle();
      },
    } as ModalAddMinutaItemClausulaModel;

    handleModifyModalAddItemInsertData(dadosModalAddItem);
  };

  const handleTooltipAddItem = async (itemId: string, clausulaId: string) => {
    var dadosModal = {
      title: 'Adicionar Descrição',
      html: '',
      text: '',
      visible: true,
      onOkRitchTextConteudo: async (htmlString: string, textString: string) => {
        await postMinutaItemClausula({
          descricao: textString,
          descricaoHtml: htmlString,
          minutaClausulaid: clausulaId,
          minutaItemClausulaid: itemId,
        });

        await onExecuteAnAfterActionHandle();
      },
    };
    handleSetDataModalRichText(dadosModal);
  };

  const handleTooltipEditItem = (item: IMinutaItemClausula, clausulaId: string) => {
    var dadosModal = {
      title: 'Editar Descrição',
      html: item.descricaoHtml,
      text: item.descricao,
      visible: true,
      onOkRitchTextConteudo: async (htmlString: string, textString: string) => {
        await putMinutaItemClausula({
          descricao: textString,
          descricaoHtml: htmlString,
          minutaClausulaid: clausulaId,
          minutaItemClausulaid: item.id,
        });

        await onExecuteAnAfterActionHandle();
      },
    };
    handleSetDataModalRichText(dadosModal);
  };

  const handleTooltipDeleteItem = (itemId: string) => {
    confirm({
      title: 'Deseja excluir este item?',
      icon: <Icon type="info-circle" />,
      content: 'Esta ação nao poderar ser desfeita, deseja continuar?',
      onOk: async () => {
        await deleteMinutaItemClausula(itemId);
        await onExecuteAnAfterActionHandle();
      },
      onCancel() { },
    });
  };

  const agruparItensClausulaPeloPai = (itens: IMinutaItemClausula[]) => {
    let agrupaPeloItemPaiId = _.groupBy(itens, 'itemPaiId');
    let arrPaisTemp = [];
    for (let pai of agrupaPeloItemPaiId['00000000-0000-0000-0000-000000000000']) {
      pai['filhos'] = agrupaPeloItemPaiId[pai.id]
        ? agrupaPeloItemPaiId[pai.id].sort((a, b) => a.ordenacao - b.ordenacao)
        : [];
      arrPaisTemp.push(pai);
    }
    return arrPaisTemp;
  }

  const renderTooltip = (item: IMinutaItemClausula, clausula: IMinutaClausula) => {
    return (
      <ReactTooltip
        id={'tooltip' + item.id}
        place="top"
        effect="solid"
        delayHide={500}
        delayShow={500}
        delayUpdate={500}
        getContent={(dataTip: any) => (
          <Row>
            <Tooltip title="Adicionar novo item aprovado">
              <Icon
                type="plus-circle"
                onClick={() => {
                  handleTooltipAddItemAprovado(item.id, clausula.tipoClausulaId, clausula.id);
                }}
              />
            </Tooltip>
            {/* Adicionar para items especiais depois
              <Tooltip title="Adicionar novo item">
              <Icon
                type="plus"
                onClick={() => {
                  handleTooltipAddItem(item.id, clausula.id);
                }}
                style={{ paddingLeft: 12 }}
              />
            </Tooltip> */}
            {!item.editavel && (
              <Tooltip title="Editar item">
                <Icon
                  type="edit"
                  onClick={() => {
                    handleTooltipEditItem(item, clausula.id);
                  }}
                  style={{ paddingLeft: 12 }}
                />
              </Tooltip>
            )}
            {!item.excluivel && (
              <Tooltip title="Excluir item">
                <Icon
                  type="delete"
                  onClick={() => {
                    handleTooltipDeleteItem(item.id);
                  }}
                  style={{ paddingLeft: 12 }}
                />
              </Tooltip>
            )}
          </Row>
        )}
      />
    );
  };

  const renderItemClausula = (idx1 = 0, idx2 = 0, idx3 = 0, item: IMinutaItemClausula, clausula: IMinutaClausula, addEspaço = false) => {
    const numeral = `${idx1}.${idx2 + 1}` + (idx3 != 0 ? `.${idx3}` : '');

    let htmlDesc = clausula.mostrarNumero == false
      ? item.descricaoHtml
      : item.descricaoHtml.replace('<p>', `<p><b>${numeral}.</b> `);

    if (addEspaço) {
      htmlDesc += " <p><br></p>";
    }

    return (
      <>
        <p
          key={'div' + item.id}
          id={generateIdHash('h', item.id)}
          className="descricao-html"
          dangerouslySetInnerHTML={{
            __html: htmlDesc,
          }}
          data-tip
          data-for={'tooltip' + item.id}
        />
        {enableTooltip && renderTooltip(item, clausula)}
      </>
    )
  }

  const renderPart1TableContent = (minutaParte1: IMinutaClausula[]) => {
    var idxGeral = 0;

    return (
      minutaParte1 &&
      minutaParte1.length > 0 && (
        <table className="table-minuta">
          <tbody>
            {minutaParte1.map((clausula: IMinutaClausula, idx1: number) => {

              idxGeral++;
              const itensPais = agruparItensClausulaPeloPai(clausula.itens);

              if (clausula.mostrarNumero == false) {
                idxGeral--;
              }

              return (
                <tr key={clausula.id} id={'item' + clausula.id}>
                  <td className="clausula-titulo">
                    {clausula.mostrarNumero == false
                      ? clausula.descricao
                      : `${idxGeral}. ${clausula.descricao}`
                    }
                  </td>
                  <td className="clausula-item">
                    {itensPais.length > 0 &&
                      itensPais.map((pai, idx2: number) => {
                        const ehUltimoItemPai = idx2 == itensPais.length - 1;
                        const addEspacoPai = (ehUltimoItemPai && pai.filhos.length > 0) || ehUltimoItemPai == false;
                        return (
                          <>
                            {renderItemClausula(idxGeral, idx2, 0, pai, clausula, addEspacoPai)}

                            {
                              pai.filhos.length > 0 && pai.filhos.map((filho: any, idx3: number) => {
                                const ehUltimoItemFilho = idx3 == pai.filhos.length - 1;
                                const addEspacoFilho = ehUltimoItemFilho == false || ehUltimoItemPai == false;
                                return renderItemClausula(idxGeral, idx2, idx3 + 1, filho, clausula, addEspacoFilho);
                              })
                            }
                          </>
                        );
                      })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )
    );
  };

  const renderPart2 = (minutaParte2: IMinutaClausula[]) => {
    let idxGeral = 0;

    return (
      minutaParte2 &&
      minutaParte2.length > 0 &&
      minutaParte2.map((clausula: IMinutaClausula, idx1: number) => {

        const itensPais = agruparItensClausulaPeloPai(clausula.itens);

        idxGeral++;

        if (clausula.mostrarNumero == false) {
          idxGeral--;
        }

        let title = clausula.mostrarNumero == false
          ? clausula.descricao.toLocaleUpperCase()
          : `CLÁUSULA ${int2roman(idxGeral)} - ${clausula.descricao.toLocaleUpperCase()}`;

        return (
          <React.Fragment key={idxGeral}>
            <p className="minuta-p2-clausula" id={'item' + clausula.id}>
              {title}
            </p>
            {
              itensPais.length > 0 &&
              itensPais.map((pai, idx2: number) => {
                return (
                  <>
                    {renderItemClausula(idxGeral, idx2, 0, pai, clausula, false)}

                    {
                      pai.filhos.length > 0 && pai.filhos.map((filho: any, idx3: number) => {
                        return renderItemClausula(idxGeral, idx2, idx3 + 1, filho, clausula, false);
                      })
                    }
                  </>
                );
              })
            }
            <p><br /></p>
          </React.Fragment>
        );
      })
    );
  };

  const renderAssinaturas = () => {
    let assHtml = `
      <div class="div-table">
        <div class="div-table-row">
          <p>Porto Trombetas, ${dataPorExtenso()}</p>
        </div>
      </div>

      <p><br/></p>

      <table style='width: 100%;' cellspacing='0' cellpadding='0' align='center' border=0 >
        <tbody>
          <tr align='center'>
            <td>      
                <span>________________________________________</span><br/>
                <span><strong>Minera&ccedil;&atilde;o Rio Norte S.A.</strong></span><br/>
                <span>Guido Roberto Campos Germani</span><br/>
                <span>Diretor Presidente</span>
            </td>
            <td>
                  <span>________________________________________</span><br/>
                  <span><strong>Minera&ccedil;&atilde;o Rio Norte S.A.</strong></span><br/>
                  <span><br/></span>
                  <span>Diretor de</span>
            </td>
          </tr>
        </tbody>
      </table >

      <p><br/></p>
      <p><br/></p>
      <p><br/></p>

      <div class="div-table">
        <div class="div-table-row">
          <p>____________________________________________________________</p>
          <p><strong>CONTRATADA</strong></p>
        </div>
      </div>

      <p><br/></p>

      <table style='width: 100%;' cellspacing='0' cellpadding='0' align='center' border=0 >
      <tbody>
        <tr align='center'>
          <td>      
                <span>________________________________________</span><br/>
                <span>Nome:</span><br/>
                <span>CPF:</span>
          </td>
          <td>
                <span>________________________________________</span><br/>
                <span>Nome:</span><br/>
                <span>CPF:</span>
          </td>
        </tr>
      </tbody>
      </table >

      <p><br/></p>
    `;

    return (
      <div
        key={'ass'}
        className="ass-html"
        dangerouslySetInnerHTML={{
          __html: assHtml,
        }}
      />
    )
  }

  return (
    <div className="minuta">
      <div className="minuta-titulo">
        <span>PARTE I – CONDIÇÕES COMERCIAIS</span>
      </div>

      <p>
        Por meio do presente instrumento particular (“Contrato”), as Partes abaixo identificadas e qualificadas têm
        entre si, justo e contratado, o quanto segue.
      </p>

      <p>
        O Contrato ora celebrado é composto pelas presentes Condições Comerciais (Parte I), assim como pelas Diretrizes
        Contratuais (Parte II) e pelos documentos Anexos, conforme abaixo, que em conjunto formam o presente Contrato.
      </p>

      {minutaItemClausulaPart1 && renderPart1TableContent(minutaItemClausulaPart1)}

      <br />
      <div className="minuta-titulo">
        <span>PARTE II – DIRETRIZES CONTRATUAIS</span>
      </div>

      <p>
        O presente instrumento estabelece as Diretrizes Contratuais para as partes Contratantes, MRN e CONTRATADA, ambas
        identificadas nas Condições Comerciais (Parte I), sendo que, após negociação quanto aos seus termos, firmam as
        Partes o presente Contrato ao final deste instrumento, rubricando as páginas das Condições Comerciais (Parte I),
        das Diretrizes Contratuais (Parte II) e dos Anexos.
      </p>

      <div className="minuta-p2">{minutaItemClausulaPart2 && renderPart2(minutaItemClausulaPart2)}</div>

      {renderAssinaturas()}

      <ModalRichText
        title={modalRichText.title}
        initialValue={modalRichText.html}
        visible={modalVisivel}
        onOkRichText={(htmlString, textString) => {
          modalRichText.onOkRitchTextConteudo(htmlString, textString);
          handleChangeModalVisible();
        }}
        onCancel={handleChangeModalVisible}
      />

      {modalAddItemData && (
        <ModalAddItemClausula
          visible={modalAddItemVisible}
          tipoClasulaId={modalAddItemData.tipoClausulaId}
          clausulaMinutaId={modalAddItemData.clausulaMinutaId}
          onSelected={(id: string) => {
            modalAddItemData.onSelected(id);
            handleModifyVisibleModalAddItem();
          }}
          onCancel={handleModifyVisibleModalAddItem}
        />
      )}
    </div>
  );
};

export default MinutaContent;
